import moment from "moment";
import { Calendar } from "lucide-react";
import { Button } from "@themes/pollinator/ui/Button";
import { createGoogleCalendarUrl } from "@core/features/calendar";
import type { Meeting } from "@core/features/meeting";
import type { ButtonVariant } from "@themes/pollinator/ui/Button";

export type Props = {
  onClick?: () => void;
  meeting: Meeting;
  eventTitle: string;
  eventDescription?: string;
  eventUrl?: string;
  onAddCalendarEvent: (
    meetingId: number,
    calendarType: "google" | "ical"
  ) => void;
  variant?: ButtonVariant;
};

export function AddToGoogleCalendarButton({
  meeting,
  onClick,
  eventTitle,
  eventDescription,
  eventUrl,
  onAddCalendarEvent,
  variant = "secondary",
}: Props) {
  const handleClick = () => {
    const calendarUrl = createGoogleCalendarUrl({
      startDateTime: moment.utc(meeting.start_time).toISOString(),
      endDateTime: moment.utc(meeting.end_time).toISOString(),
      eventTitle: eventTitle,
      eventDescription: eventDescription,
      eventUrl: eventUrl,
    });

    onAddCalendarEvent(meeting.id, "google");

    onClick?.();

    window.open(calendarUrl, "_blank");
  };

  return (
    <Button
      variant={variant}
      iconComponent={Calendar}
      onClick={handleClick}
    >
      Add to Google Cal
    </Button>
  );
}

export default AddToGoogleCalendarButton;
